// src/App.js
//
// Same overall shape as the AFSC reference App.js (Router, a list of
// Routes, protected ones wrapped in PrivateRoute) with one difference:
// no basename -- AFSC deploys under /afsc-platform; this app isn't
// deployed anywhere yet, so there's nothing to set that to. Add one
// later if/when this ends up hosted under a subpath.
//
// Every route below is a real page now -- no more Page() placeholder.

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import ProjectListPage from "./pages/ProjectListPage";
import NewProjectPage from "./pages/NewProjectPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import OrgDashboardPage from "./pages/OrgDashboardPage";
import MyDashboardPage from "./pages/MyDashboardPage";
import ImportExportPage from "./pages/ImportExportPage";
import PrivateRoute from "./components/PrivateRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/projects"
          element={
            <PrivateRoute>
              <ProjectListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects/new"
          element={
            <PrivateRoute>
              <NewProjectPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects/:projectId"
          element={
            <PrivateRoute>
              <ProjectDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <OrgDashboardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard/mine"
          element={
            <PrivateRoute>
              <MyDashboardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/import-export"
          element={
            <PrivateRoute>
              <ImportExportPage />
            </PrivateRoute>
          }
        />

        <Route path="/" element={<Navigate to="/projects" />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
